<template lang="pug">
main.view-y(role="main" :class="'theme-'+ theme")
  router-view
</template>

<script>
import config from "@/config"
export default {
  components: {},
  computed: {
    theme() {
      return config.brandName.toLowerCase();
    },
  },
  mounted: function() {}
};
</script>
